import { maximum } from 'components/calendar/calendarUtil'
import DateRangePicker from 'components/calendar/DateRangePicker'
import useCalendarRange from 'components/calendar/useCalendarRange'
import moment from 'moment'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import NoneAnchor from 'components/NoneAnchor'
import DashboardFilter from 'features/dashboard/filter/DashboardFilter'
import classNames from 'classnames'
import {
  refreshDashboard,
  setPeriod,
} from 'features/dashboard/dashboardCommonSlice'
import { dateformat } from 'utils'
import Tooltip from 'components/tooltip/Tooltip'
import { setVisible as setTreeVisible } from 'features/dashboard/tree/dashboardTreeSlice'
import { setVisible as setInfoVisible } from 'features/dashboard/info/dashboardInfoSlice'

const DashboardTitle = () => {
  const dispatch = useDispatch()
  const { preset, from, to, isRefreshing, lastUpdatedTimestamp } = useSelector(
    state => state.dashboard.common,
    shallowEqual
  )
  const { visible: treeVisible } = useSelector(state => state.dashboard.tree)
  const handleTreeVisible = () => {
    dispatch(setTreeVisible(!treeVisible))
  }
  const { visible: infoVisible } = useSelector(state => state.dashboard.info)
  const handleInfoVisible = () => {
    dispatch(setInfoVisible(!infoVisible))
  }
  const { min, max } = useCalendarRange(moment().subtract(2, 'year'))
  const handleDateRangeChange = (start, end, calendarPreset) => {
    dispatch(
      setPeriod({
        from: start,
        to: end,
        preset: calendarPreset,
      })
    )
  }
  return (
    <div className="dashboard_check">
      <div className="inner_g">
        <div className="wrap_option">
          <NoneAnchor
            className={classNames('link_view', { on: treeVisible })}
            onClick={() => handleTreeVisible()}>
            트리보기<span className="ico_comm ico_treeview">트리영역 닫기</span>
          </NoneAnchor>
          <NoneAnchor
            className={classNames('link_view', { on: infoVisible })}
            onClick={() => handleInfoVisible()}>
            정보보기<span className="ico_comm ico_chart">정보영역 닫기</span>
          </NoneAnchor>
        </div>
        <DashboardFilter />
        <div className="wrap_calendar">
          <DateRangePicker
            className="reform_box_calendar"
            tiaraPrefix="대시보드"
            start={maximum(min, from)}
            end={to}
            preset={preset}
            min={min}
            max={max}
            onChange={handleDateRangeChange}
          />
          <Tooltip
            wrapperClassName="inner_g icon_g"
            container="dashboardWrap"
            position="bottom alignRight"
            content={`${moment(lastUpdatedTimestamp).format(dateformat)} 기준`}
            offsetY={8}>
            <NoneAnchor
              onClick={() => dispatch(refreshDashboard())}
              className={classNames('btn_gm gm_line btn_refresh', {
                in_active: isRefreshing,
              })}>
              <span className="inner_g icon_g">
                <span className="ico_comm">새로고침</span>
              </span>
            </NoneAnchor>
          </Tooltip>
        </div>
      </div>
    </div>
  )
}
export default DashboardTitle
